import {UseFormReturnType} from "@mantine/form";
import {useTranslation} from "react-i18next";
import {Button, Divider, Grid, Modal, ModalProps, Textarea, TextInput} from "@mantine/core";
import {useCallback} from "react";
import {useRoleForm} from "./useRoleForm";

export interface RoleFormProps {
  options?: RoleFormOptions;
  defaultValues?: RoleFormDefaultValues;
  onSubmit?: (values: RoleFormValues) => void;
  submitting?: boolean;
}

export interface RoleFormOptions {

}

export interface RoleFormValues {
  name: string;
  description?: string;
}

export interface RoleFormDefaultValues extends Partial<RoleFormValues> {

}

export interface RoleFormRawValues {
  name?: string;
  description?: string;
}

export type RoleFormType = UseFormReturnType<RoleFormRawValues, (values: RoleFormRawValues) => RoleFormRawValues>

export const RoleForm = (props: RoleFormProps) => {
  const {
    options,
    defaultValues,
    onSubmit,
    submitting = false
  } = props;

  const {t} = useTranslation(["common"]);

  const form = useRoleForm({
    defaultValues: defaultValues,
  });

  const onFormSubmit = useCallback(async (values: typeof form.values) => {

    if (onSubmit) {
      onSubmit({
        name: values.name!,
        description: values.description,
      });
    }
  }, [form, onSubmit]);

  return (
    <form onSubmit={form.onSubmit(onFormSubmit)}>
      <Grid grow gutter="xs">
        <Grid.Col span={12}>
          <TextInput
            label={t("common.entity.role.form.field.name", "Name")}
            placeholder={t<string>("common.entity.role.form.field.name.placeholder", "Name")}
            withAsterisk
            required
            {...form.getInputProps("name")} />
        </Grid.Col>
        <Grid.Col span={12}>
          <Textarea
            label={t("common.entity.role.form.field.description", "Description")}
            placeholder={t<string>("common.entity.role.form.field.description.placeholder", "Description")}
            {...form.getInputProps("description")} />
        </Grid.Col>
      </Grid>
      <Divider my="sm" variant="dotted"/>
      <Button type="submit" loading={submitting} fullWidth mt="xl">
        {t("common.action.submit", {ns: "common"})}
      </Button>
    </form>
  );
};

interface RoleFormModalProps extends RoleFormProps, Omit<ModalProps, 'onSubmit'> {

}

export const RoleFormModal = (props: RoleFormModalProps) => {
  const {
    defaultValues,
    onSubmit,
    submitting,
    ...rest
  } = props;

  return (
    <Modal {...rest}>
      <RoleForm defaultValues={defaultValues} onSubmit={onSubmit} submitting={submitting}/>
    </Modal>
  );
};
